import React from "react";
import { useQueryClient } from "@tanstack/react-query";
import OnboardingLayout from "./OnboardingLayout";
import NotificationPopUp from "../NotificationPopUp";
import "../../Animations.css";

interface NotificationStepProps {
  onClose: () => void;
}

const NotificationStep: React.FC<NotificationStepProps> = ({ onClose }) => {
  const queryClient = useQueryClient();

  const handleNotificationClose = () => {
    // Invalidate the userInfo query to refetch the data
    queryClient.invalidateQueries({ queryKey: ["userInfo"] });
    onClose();
  };

  return (
    <OnboardingLayout
      title="Never miss a Spanish lesson again"
      subtitle="86% of users hit their goals with daily reminders"
    >
      <div className="flex flex-col w-full gap-3 justify-center items-center">
        <NotificationPopUp onClose={handleNotificationClose} />
        <div className="flex justify-center ml-32 items-center emoji-bounce text-xxl">
          👆
        </div>
      </div>
    </OnboardingLayout>
  );
};

export default NotificationStep;
